"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalProvider = exports.ModalContext = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const route_util_1 = require("../../@common/util/route-util");
const SlideModal_1 = __importDefault(require("../SlideModal"));
const BaseModal_1 = __importDefault(require("../BaseModal"));
const __1 = require("..");
const ApplicationFrame_1 = __importDefault(require("../../ApplicationFrame"));
const getModal = (variant) => {
    switch (variant) {
        case __1.ModalVariant.DEFAULT:
            return BaseModal_1.default;
        case __1.ModalVariant.HALF_SLIDE:
        case __1.ModalVariant.FULL_SLIDE:
            return SlideModal_1.default;
        default:
            throw new Error(`Modal Variant not found <${variant}>`);
    }
};
const getDefaultModalOptions = () => ({
    closeOnBackdropClick: false,
    draggable: false,
    draggableOptions: {}
});
const getDefaultModalState = () => ({
    isOpen: false,
    isRouteActionChanging: false,
    routeAction: null,
    routeWhenModalOpened: null,
    body: null,
    variant: __1.ModalVariant.DEFAULT,
    options: getDefaultModalOptions(),
    titleText: '',
    Title: undefined,
    CloseButton: undefined
});
const resolvePayload = (payload, mixinOptions = {}) => {
    const { options = {} } = payload, updates = __rest(payload, ["options"]);
    const modalOptions = Object.assign(Object.assign(Object.assign({}, getDefaultModalOptions()), mixinOptions), options);
    return Object.assign(Object.assign({}, updates), { options: modalOptions });
};
const modalReducer = (state, action) => {
    var _a;
    switch (action.type) {
        case 'OPEN_MODAL':
            return Object.assign(Object.assign(Object.assign({}, state), resolvePayload(action.payload)), { variant: __1.ModalVariant.DEFAULT, isOpen: true });
        case 'OPEN_APPLICATION_IFRAME_MODAL': {
            const _b = action.payload, { bodyProps } = _b, payload = __rest(_b, ["bodyProps"]);
            return Object.assign(Object.assign(Object.assign({}, state), resolvePayload(payload)), { variant: __1.ModalVariant.DEFAULT, body: (react_1.default.createElement(ApplicationFrame_1.default, Object.assign({}, bodyProps, { staticHeightAdjust: (_a = bodyProps.staticHeightAdjust) !== null && _a !== void 0 ? _a : 60 }))), getPaperStyles: (_a) => {
                    var { width, height, display, flex } = _a, defaultStyles = __rest(_a, ["width", "height", "display", "flex"]);
                    return defaultStyles;
                }, isOpen: true });
        }
        case 'OPEN_DRAGGABLE_MODAL':
            return Object.assign(Object.assign(Object.assign({}, state), resolvePayload(action.payload, { draggable: true })), { variant: __1.ModalVariant.DEFAULT, isOpen: true });
        case 'OPEN_HALF_SLIDE_MODAL':
            return Object.assign(Object.assign(Object.assign({}, state), resolvePayload(action.payload)), { variant: __1.ModalVariant.HALF_SLIDE, isOpen: true });
        case 'OPEN_FULL_SLIDE_MODAL':
            return Object.assign(Object.assign(Object.assign({}, state), resolvePayload(action.payload)), { variant: __1.ModalVariant.FULL_SLIDE, isOpen: true });
        case 'ROUTE_ACTION_CHANGING':
            return Object.assign(Object.assign({}, state), { isRouteActionChanging: action.payload });
        case 'PERSIST_ROUTE_WHEN_MODAL_OPENED':
            return Object.assign(Object.assign({}, state), { routeWhenModalOpened: action.payload });
        case 'CLOSE_MODAL':
            return getDefaultModalState();
        default:
            return getDefaultModalState();
    }
};
/**
 * UseModal should be used to control modal state and UI display
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.ModalContext = react_1.default.createContext([]);
const ModalProvider = props => {
    const navigate = react_router_dom_1.useNavigate();
    const location = react_router_dom_1.useLocation();
    const [state, dispatch] = react_1.useReducer(modalReducer, getDefaultModalState());
    const CloseButton = react_1.useMemo(() => {
        var _a;
        if (state.CloseButton === null)
            return null;
        return (_a = state.CloseButton) !== null && _a !== void 0 ? _a : props.CloseButton;
    }, [state.CloseButton, props.CloseButton]);
    const Title = react_1.useMemo(() => {
        var _a;
        if (state.Title === null)
            return null;
        return (_a = state.Title) !== null && _a !== void 0 ? _a : props.Title;
    }, [state.Title, props.Title]);
    const Modal = react_1.useMemo(() => getModal(state.variant), [state.variant]);
    const getRoute = react_1.useCallback((routeAction, routeParams = {}) => {
        let route = window.location.href;
        if (routeAction && !window.location.search.includes(routeAction)) {
            route = `${window.location.pathname}${route_util_1.makeActionRouteParams({
                locationSearch: window.location.search,
                action: routeAction,
                routeParams,
                actionKeyFn: route_util_1.makeModalRouteAction,
                actionParamKeyFn: route_util_1.getActionKey
            })}`;
        }
        return route;
    }, []);
    const maybeNavigate = react_1.useCallback((route) => {
        if (route !== window.location.href)
            navigate(route);
    }, [navigate]);
    const openModal = react_1.useCallback((_a) => {
        var { routeAction = null, routeParams } = _a, payload = __rest(_a, ["routeAction", "routeParams"]);
        const route = getRoute(routeAction, routeParams);
        dispatch({
            type: 'OPEN_MODAL',
            payload: Object.assign(Object.assign({}, payload), { routeAction, routeWhenModalOpened: route })
        });
        maybeNavigate(route);
    }, [maybeNavigate, dispatch, getRoute]);
    const openApplicationIFrameModal = react_1.useCallback((_a) => {
        var { routeAction = null, routeParams } = _a, payload = __rest(_a, ["routeAction", "routeParams"]);
        const route = getRoute(routeAction, routeParams);
        dispatch({
            type: 'OPEN_APPLICATION_IFRAME_MODAL',
            payload: Object.assign(Object.assign({}, payload), { routeAction, routeWhenModalOpened: route })
        });
        maybeNavigate(route);
    }, [maybeNavigate, dispatch, getRoute]);
    const openHalfSlideModal = (_a) => {
        var { routeAction = null, routeParams } = _a, payload = __rest(_a, ["routeAction", "routeParams"]);
        const route = getRoute(routeAction, routeParams);
        dispatch({
            type: 'OPEN_HALF_SLIDE_MODAL',
            payload: Object.assign(Object.assign({}, payload), { routeAction, routeWhenModalOpened: route })
        });
        maybeNavigate(route);
    };
    const openFullSlideModal = (_a) => {
        var { routeAction = null, routeParams } = _a, payload = __rest(_a, ["routeAction", "routeParams"]);
        const route = getRoute(routeAction, routeParams);
        dispatch({
            type: 'OPEN_FULL_SLIDE_MODAL',
            payload: Object.assign(Object.assign({}, payload), { routeAction, routeWhenModalOpened: route })
        });
        maybeNavigate(route);
    };
    const openDraggableModal = react_1.useCallback((_a) => {
        var { routeAction = null, routeParams } = _a, payload = __rest(_a, ["routeAction", "routeParams"]);
        const route = getRoute(routeAction, routeParams);
        dispatch({
            type: 'OPEN_DRAGGABLE_MODAL',
            payload: Object.assign(Object.assign({}, payload), { routeAction, routeWhenModalOpened: route })
        });
        maybeNavigate(route);
    }, [maybeNavigate, dispatch, getRoute]);
    const closeModal = react_1.useCallback(() => {
        if (state.handleOnClose) {
            state.handleOnClose();
        }
        if (window.location.search.includes(route_util_1.getModalActionKey())) {
            dispatch({ type: 'ROUTE_ACTION_CHANGING', payload: true });
            navigate(`${window.location.pathname}${route_util_1.makeActionRouteParams({
                locationSearch: window.location.search
            })}`, { replace: true });
            dispatch({ type: 'ROUTE_ACTION_CHANGING', payload: false });
        }
        dispatch({ type: 'CLOSE_MODAL' });
        if (state.handleAfterClose) {
            state.handleAfterClose();
        }
    }, [state, dispatch, navigate]);
    react_1.useEffect(() => {
        if (state.isOpen && window.location.href !== state.routeWhenModalOpened) {
            closeModal();
        }
    }, [location, state.routeWhenModalOpened, state.isOpen, closeModal]);
    return (react_1.default.createElement(exports.ModalContext.Provider, { value: [
            state,
            {
                openModal,
                openFullSlideModal,
                openHalfSlideModal,
                openDraggableModal,
                openApplicationIFrameModal,
                closeModal
            }
        ] },
        state.isOpen && (react_1.default.createElement(Modal, { open: true, onClose: closeModal, variant: state.variant, options: state.options, getDialogStyles: state.getDialogStyles, getPaperStyles: state.getPaperStyles, getContainerStyles: state.getContainerStyles, titleText: state.titleText, Title: Title, CloseButton: CloseButton, ariaLabel: state === null || state === void 0 ? void 0 : state.ariaLabel }, state.body)),
        props.children));
};
exports.ModalProvider = ModalProvider;
exports.default = exports.ModalProvider;
